if (!customElements.get('popup-video')) {
  class PopupVideo extends HTMLElement {
    constructor() {
      super();

      this.addScriptFile();

      this.buttonClose = this.querySelector('[data-popup-close]');
      this.popupIframe = this.querySelector('[data-popup-iframe]');
      this.iframeSrc = null;

      this.addEventListener('click', (e) => {
        const isOverlayClick = e.target === this;

        if (!isOverlayClick) return;

        this.close();
      });

      this.addEventListener('keydown', (e) => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) return;

        this.close();
      });

      this.buttonClose.addEventListener('click', (e) => {
        e.preventDefault();

        this.close();
      });
    }

    open() {
      trapFocus(this, this.buttonClose);
      this.classList.add('is-visible');
      document.body.style.overflow = 'hidden';

      if(this.iframeSrc !== this.popupIframe.src) {
        this.player = new YT.Player(this.popupIframe, {
          events: {
            'onReady': () => {
              this.player.playVideo();
            }
          }
        });
      } else {
        this.player.playVideo();
      }

      this.iframeSrc = this.popupIframe.src;
    }

    close() {
      removeTrapFocus();
      this.classList.remove('is-visible');
      document.body.style.overflow = '';
      this.player?.stopVideo();
    }

    addScriptFile() {
      const tag = document.createElement('script');
      const firstScriptTag = document.getElementsByTagName('script')[0];

      tag.src = 'https://www.youtube.com/iframe_api';
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  customElements.define('popup-video', PopupVideo);
}
